import { render, staticRenderFns } from "./BlogPagination.vue?vue&type=template&id=019e1ee0&"
import script from "./BlogPagination.vue?vue&type=script&lang=js&"
export * from "./BlogPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports